import Slider from "react-slick";
import { Box, makeStyles } from "@material-ui/core";
import { sliderSettings } from "../../../components/Slider";
import { Media, Product } from "../../../api/Product/Product";

export const RecommendedProductSlider = ({ product }: Props) => {
  const classes = useStyles();

  if (product === null) {
    return null;
  }

  const slideRender = function (media: Media) {
    if (media === null || media.mediaFiles === null) {
      return null;
    }

    return (
      <Box
        key={media.id}
        width={"100%"}
        height={"100%"}
        display={"flex !important"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img alt={media.description} src={media.mediaFiles[0].url} />
      </Box>
    );
  };

  return (
    <Box width={"100%"} height={"100%"}>
      <Slider {...sliderSettings} autoplay={true} autoplaySpeed={6000} className={classes.imageSlider}>
        {product.media.map((m) => slideRender(m))}
      </Slider>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  imageSlider: {
    "height": "100%",
    "& .slick-list": {
      "height": "100%",
      "& .slick-track": {
        height: "100%"
      }
    },
    "& .slick-dots li": {
      margin: 0
    },
    "& .slick-dots li button": {
      [theme.breakpoints.down("sm")]: {
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots li button:before": {
      fontSize: "10px",
      color: "#f7815c",
      [theme.breakpoints.down("sm")]: {
        fontSize: "7px",
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots .slick-active button:before": {
      opacity: 1
    },
    "& .slick-slide div": {
      height: "100%"
    },
    "& .slick-slide img": {
      maxHeight: "321px",
      maxWidth: "300px",
      objetFit: "cover",
      outline: "transparent",
      [theme.breakpoints.down("md")]: {
        maxHeight: "320px",
        maxWidth: "220px"
      }
    },
    "& .slick-slide .MuiBox-root": {
      outline: "transparent"
    },
    "& .slick-next, & .slick-prev": {
      display: "none !important"
    },
    "& .slick-dots": {
      bottom: "20px",
      [theme.breakpoints.down("sm")]: {
        bottom: "0px"
      }
    }
  }
}));

interface Props {
  product: Product | null;
}
